.scroller {
  min-inline-size: 0;
  overflow: auto;
  overscroll-behavior-inline: contain;
  border: var(--border-width) solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
}

.scroller[data-sticky-header] {
  max-block-size: calc(100dvh - var(--header-height) - var(--space-12) * 4);
}

.table {
  inline-size: 100%;
  font-size: var(--text-sm);
  line-height: var(--leading-tight);
}

.caption {
  padding: var(--space-3) var(--space-3) 0;
  font-size: var(--text-md);
  font-weight: var(--weight-semibold);
  text-align: start;
}

.hiddenCaption {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.headerCell {
  block-size: var(--control-md);
  padding: 0 var(--space-3);
  border-block-end: var(--border-width) solid var(--color-border);
  background: var(--color-surface-sunken);
  color: var(--color-text-muted);
  font-weight: var(--weight-medium);
  text-align: start;
  white-space: nowrap;
}

.scroller[data-sticky-header] .headerCell {
  position: sticky;
  inset-block-start: 0;
  z-index: var(--z-sticky);
}

.sortButton {
  display: inline-flex;
  gap: var(--space-1);
  align-items: center;
  block-size: var(--control-sm);
  margin-inline: calc(var(--space-1) * -1);
  padding-inline: var(--space-1);
  border-radius: var(--radius-sm);
  color: inherit;
  font-weight: inherit;
  cursor: default;
}

@media (hover: hover) and (pointer: fine) {
  .sortButton:hover {
    color: var(--color-text);
  }
}

.sortIcon {
  display: inline-flex;
  color: var(--color-text-subtle);
}

.sortIcon[data-active] {
  color: var(--color-text);
}

.row {
  block-size: var(--control-md);
}

@media (hover: hover) and (pointer: fine) {
  .row:not([data-skeleton]):hover {
    background: var(--color-surface-hover);
  }
}

.row[data-selected] {
  background: var(--color-accent-subtle);
}

.cell {
  padding: var(--space-1) var(--space-3);
  border-block-end: var(--border-width) solid var(--color-border);
  color: var(--color-text);
  vertical-align: middle;
}

.table tbody tr:last-child > .cell {
  border-block-end: 0;
}

.cell[data-numeric],
.headerCell[data-numeric] {
  text-align: end;
  font-variant-numeric: var(--numeric);
  white-space: nowrap;
}

.headerCell[data-numeric] .sortButton {
  flex-direction: row-reverse;
}

.cell[data-align="center"],
.headerCell[data-align="center"] {
  text-align: center;
}

.cell[data-align="end"],
.headerCell[data-align="end"] {
  text-align: end;
}

.cell[data-mono] {
  font-family: var(--font-mono);
  letter-spacing: var(--tracking-wide);
  white-space: nowrap;
}

.cell[data-width="fit"],
.headerCell[data-width="fit"] {
  inline-size: 1%;
  white-space: nowrap;
}

.cell[data-width="wide"],
.headerCell[data-width="wide"] {
  inline-size: 40%;
}

.cell[data-truncate] {
  max-inline-size: 0;
}

.truncate {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.actionsCell {
  inline-size: 1%;
  padding-inline: var(--space-1);
  text-align: end;
  white-space: nowrap;
}

.scroller[data-sticky-first-column] .cell:first-child,
.scroller[data-sticky-first-column] .headerCell:first-child {
  position: sticky;
  inset-inline-start: 0;
  background: var(--color-surface);
}

.scroller[data-sticky-first-column] .headerCell:first-child {
  z-index: var(--z-sticky-corner);
  background: var(--color-surface-sunken);
}

.stateCell {
  padding: var(--space-4);
}

.pendingCell {
  block-size: calc(var(--control-md) * 3);
}

.footer td,
.footer th {
  padding: var(--space-2) var(--space-3);
  border-block-start: var(--border-width) solid var(--color-border-strong);
  font-weight: var(--weight-semibold);
}
